import React, { useEffect } from 'react'
import lottie from 'lottie-web';


const Loading = ({height = 200, top=10}) => {
    const loadingfRef = React.useRef(null)


      useEffect(()=>{
            lottie.loadAnimation({
                container : loadingfRef.current,
                renderer : 'svg',
                loop : true,
                autoplay : true,
                animationData : require('../../assert/loading.json')
            })
      })


    return (
       <div style={{height : height, margin:'0 auto', width:'100%', marginTop:top}} ref={loadingfRef}>
           
       </div>
            
    )
}

export default Loading
